import React from 'react';
import PageContainer from '../components/PageContainer';
import { FiSettings, FiStar, FiCreditCard, FiLogOut, FiEdit2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Profile() {
  return (
    <PageContainer>
      <div className="flex flex-col md:flex-row gap-8">
        
        {/* Sidebar / User Info */}
        <div className="w-full md:w-1/3 space-y-6">
          <div className="bg-grunge-gray border border-gray-700 rounded-xl p-6 text-center relative">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-sun-yellow">
              <SafeIcon icon={FiEdit2} />
            </button>
            <div className="w-32 h-32 mx-auto rounded-full border-4 border-sun-yellow overflow-hidden mb-4 p-1">
              <img 
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=400&auto=format&fit=crop" 
                alt="User Avatar" 
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <h2 className="text-2xl font-bold text-white">Alex RockFan</h2>
            <p className="text-gray-400 mb-4">Member since 2019</p>
            
            <div className="inline-flex items-center gap-2 bg-sun-yellow/20 text-sun-yellow px-4 py-2 rounded-full border border-sun-yellow/50 font-bold text-sm">
              <SafeIcon icon={FiStar} className="fill-current" /> ALL-ACCESS VIP
            </div>
          </div>

          <div className="bg-grunge-gray border border-gray-700 rounded-xl overflow-hidden">
            <nav className="flex flex-col">
              <a href="#" className="flex items-center gap-3 px-6 py-4 text-sun-yellow bg-gray-800 border-l-4 border-sun-yellow font-bold">
                <SafeIcon icon={FiSettings} /> Account Settings
              </a>
              <a href="#" className="flex items-center gap-3 px-6 py-4 text-gray-300 hover:bg-gray-800 hover:text-white transition-colors border-l-4 border-transparent">
                <SafeIcon icon={FiCreditCard} /> Membership & Billing
              </a>
              <a href="#" className="flex items-center gap-3 px-6 py-4 text-red-400 hover:bg-gray-800 hover:text-red-300 transition-colors border-l-4 border-transparent">
                <SafeIcon icon={FiLogOut} /> Sign Out
              </a>
            </nav>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="w-full md:w-2/3 space-y-6">
          
          {/* Dashboard Stats/Quick Info */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-black/50 border border-gray-700 rounded-xl p-6">
              <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">Presale Code</p>
              <p className="text-2xl font-display text-white tracking-widest">MBVIP24X</p>
            </div>
            <div className="bg-black/50 border border-gray-700 rounded-xl p-6">
              <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">Forum Posts</p>
              <p className="text-2xl font-display text-white">142</p>
            </div>
          </div>

          {/* Form Settings */}
          <div className="bg-grunge-gray border border-gray-700 rounded-xl p-6 md:p-8">
            <h3 className="text-xl font-display text-sun-yellow mb-6 border-b border-gray-700 pb-2">Profile Information</h3>
            
            <form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-bold text-gray-400 mb-2">First Name</label>
                  <input type="text" defaultValue="Alex" className="w-full bg-black border border-gray-600 rounded p-3 text-white focus:outline-none focus:border-sun-yellow" />
                </div>
                <div>
                  <label className="block text-sm font-bold text-gray-400 mb-2">Last Name</label>
                  <input type="text" defaultValue="RockFan" className="w-full bg-black border border-gray-600 rounded p-3 text-white focus:outline-none focus:border-sun-yellow" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-400 mb-2">Email Address</label>
                <input type="email" defaultValue="alex@example.com" className="w-full bg-black border border-gray-600 rounded p-3 text-white focus:outline-none focus:border-sun-yellow" />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-400 mb-2">Location</label>
                <input type="text" defaultValue="Seattle, WA" className="w-full bg-black border border-gray-600 rounded p-3 text-white focus:outline-none focus:border-sun-yellow" />
              </div>

              <div className="flex items-center gap-3 pt-4">
                <input type="checkbox" id="newsletter" defaultChecked className="w-5 h-5 accent-sun-yellow" />
                <label htmlFor="newsletter" className="text-gray-300">Receive club exclusive newsletters and updates</label>
              </div>

              <div className="pt-6 border-t border-gray-700 flex justify-end">
                <button type="button" className="bg-sun-yellow text-black font-bold py-3 px-8 rounded hover:bg-white transition-colors uppercase">
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>

      </div>
    </PageContainer>
  );
}